import React from 'react';
import './Title.scss';

const Title = ({ text, className }) => {
  return (
    <div className={`titleWrapper ${className || ''}`}>
      <h2 className="title">{text}</h2>
      <div className="underline"></div>
    </div>
  );
};

export default Title;
